import { render, staticRenderFns } from "./auth-reset.vue?vue&type=template&id=0d38fbf0&scoped=true&"
import script from "./auth-reset.vue?vue&type=script&lang=js&"
export * from "./auth-reset.vue?vue&type=script&lang=js&"
import style0 from "./auth-reset.vue?vue&type=style&index=0&id=0d38fbf0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d38fbf0",
  null
  
)

export default component.exports